const ITEMS = [
    "FRP Sheets",
    "GFRP",
    "Epoxy Fiberglass",
    "FRP Epoxy Boxes",
    "Electrical Insulation",
    "Transformer Components",
    "FRP Rods & Profiles",
    "Custom Moulded Parts",
];

const Row = ({ ariaHidden = false }) => (
    <div className="flex items-center shrink-0" aria-hidden={ariaHidden}>
        {ITEMS.map((item) => (
            <span key={item} className="flex items-center shrink-0">
                <span className="font-display uppercase font-medium tracking-wide text-lg md:text-2xl text-zinc-200 px-6 md:px-10">
                    {item}
                </span>
                <svg width="12" height="12" viewBox="0 0 12 12" className="text-safety shrink-0">
                    <rect x="2" y="2" width="8" height="8" fill="currentColor" transform="rotate(45 6 6)" />
                </svg>
            </span>
        ))}
    </div>
);

export const Marquee = () => (
    <div className="border-y border-zinc-800 bg-[#0e0e11] py-5 overflow-hidden" data-testid="editorial-marquee">
        <div className="marquee-track">
            <Row />
            <Row ariaHidden />
        </div>
    </div>
);

export default Marquee;